export function uploadFileWithProgress({
  url,
  file,
  headers = {},
  method = "PUT",
  onProgress = null,
  signal = null,
}) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("upload url is required"));
      return;
    }
    if (!(file instanceof File)) {
      reject(new Error("a File object is required"));
      return;
    }

    const xhr = new XMLHttpRequest();
    xhr.open(method || "PUT", url);
    xhr.responseType = "text";

    Object.entries(headers || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      xhr.setRequestHeader(key, String(value));
    });

    const cleanup = (abortListener) => {
      xhr.onload = null;
      xhr.onerror = null;
      xhr.onabort = null;
      if (xhr.upload) {
        xhr.upload.onprogress = null;
      }
      if (signal && abortListener) {
        signal.removeEventListener("abort", abortListener);
      }
    };

    const abortListener = () => {
      xhr.abort();
    };

    if (signal) {
      if (signal.aborted) {
        cleanup(null);
        reject(new Error("upload aborted"));
        return;
      }
      signal.addEventListener("abort", abortListener, { once: true });
    }

    if (xhr.upload && typeof onProgress === "function") {
      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable || !event.total) return;
        const ratio = event.loaded / event.total;
        onProgress(Math.max(0, Math.min(1, ratio)));
      };
    }

    xhr.onload = () => {
      cleanup(abortListener);
      resolve({
        status: xhr.status,
        body: xhr.responseText,
      });
    };

    xhr.onerror = () => {
      cleanup(abortListener);
      reject(new Error("upload request failed"));
    };

    xhr.onabort = () => {
      cleanup(abortListener);
      reject(new Error("upload aborted"));
    };

    try {
      xhr.send(file);
    } catch (error) {
      cleanup(abortListener);
      reject(error);
    }
  });
}
